/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthErrorRouteImport } from './routes/auth-error'
import { Route as AuthRoutesRouteImport } from './routes/_auth-routes'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRoutesAdminVariableCostsRouteImport } from './routes/_auth-routes/admin/variableCosts'
import { Route as AuthRoutesAdminVariableCostRouteImport } from './routes/_auth-routes/admin/variableCost'
import { Route as AuthRoutesAdminUsersRouteImport } from './routes/_auth-routes/admin/users'
import { Route as AuthRoutesAdminUserRouteImport } from './routes/_auth-routes/admin/user'
import { Route as AuthRoutesAdminUptakesRouteImport } from './routes/_auth-routes/admin/uptakes'
import { Route as AuthRoutesAdminUptakeRouteImport } from './routes/_auth-routes/admin/uptake'
import { Route as AuthRoutesAdminTableViewsRouteImport } from './routes/_auth-routes/admin/tableViews'
import { Route as AuthRoutesAdminTableViewRouteImport } from './routes/_auth-routes/admin/tableView'
import { Route as AuthRoutesAdminScenariosRouteImport } from './routes/_auth-routes/admin/scenarios'
import { Route as AuthRoutesAdminScenarioRouteImport } from './routes/_auth-routes/admin/scenario'
import { Route as AuthRoutesAdminSalesRouteImport } from './routes/_auth-routes/admin/sales'
import { Route as AuthRoutesAdminSaleRouteImport } from './routes/_auth-routes/admin/sale'
import { Route as AuthRoutesAdminRoyaltyRouteImport } from './routes/_auth-routes/admin/royalty'
import { Route as AuthRoutesAdminRoyaltiesRouteImport } from './routes/_auth-routes/admin/royalties'
import { Route as AuthRoutesAdminProjectsRouteImport } from './routes/_auth-routes/admin/projects'
import { Route as AuthRoutesAdminProjectPhasesRouteImport } from './routes/_auth-routes/admin/projectPhases'
import { Route as AuthRoutesAdminProjectPhaseRouteImport } from './routes/_auth-routes/admin/projectPhase'
import { Route as AuthRoutesAdminProjectCategoryRouteImport } from './routes/_auth-routes/admin/projectCategory'
import { Route as AuthRoutesAdminProjectCategoriesRouteImport } from './routes/_auth-routes/admin/projectCategories'
import { Route as AuthRoutesAdminProjectRouteImport } from './routes/_auth-routes/admin/project'
import { Route as AuthRoutesAdminPhasesRouteImport } from './routes/_auth-routes/admin/phases'
import { Route as AuthRoutesAdminPhaseRouteImport } from './routes/_auth-routes/admin/phase'
import { Route as AuthRoutesAdminPeriodsRouteImport } from './routes/_auth-routes/admin/periods'
import { Route as AuthRoutesAdminPeriodRouteImport } from './routes/_auth-routes/admin/period'
import { Route as AuthRoutesAdminMilestonesRouteImport } from './routes/_auth-routes/admin/milestones'
import { Route as AuthRoutesAdminMilestoneRouteImport } from './routes/_auth-routes/admin/milestone'
import { Route as AuthRoutesAdminFinancialsRouteImport } from './routes/_auth-routes/admin/financials'
import { Route as AuthRoutesAdminFinancialRouteImport } from './routes/_auth-routes/admin/financial'
import { Route as AuthRoutesAdminFilesRouteImport } from './routes/_auth-routes/admin/files'
import { Route as AuthRoutesAdminFileRouteImport } from './routes/_auth-routes/admin/file'
import { Route as AuthRoutesAdminConfigsRouteImport } from './routes/_auth-routes/admin/configs'
import { Route as AuthRoutesAdminConfigRouteImport } from './routes/_auth-routes/admin/config'
import { Route as AuthRoutesAdminCommentsRouteImport } from './routes/_auth-routes/admin/comments'
import { Route as AuthRoutesAdminCommentRouteImport } from './routes/_auth-routes/admin/comment'
import { Route as AuthRoutesAdminCategoryValuesRouteImport } from './routes/_auth-routes/admin/categoryValues'
import { Route as AuthRoutesAdminCategoryValueRouteImport } from './routes/_auth-routes/admin/categoryValue'
import { Route as AuthRoutesAdminCategoryRouteImport } from './routes/_auth-routes/admin/category'
import { Route as AuthRoutesAdminCategoriesRouteImport } from './routes/_auth-routes/admin/categories'
import { Route as AuthRoutesAdminActionsRouteImport } from './routes/_auth-routes/admin/actions'
import { Route as AuthRoutesAdminActionOperationsRouteImport } from './routes/_auth-routes/admin/actionOperations'
import { Route as AuthRoutesAdminActionOperationRouteImport } from './routes/_auth-routes/admin/actionOperation'
import { Route as AuthRoutesAdminActionRouteImport } from './routes/_auth-routes/admin/action'

const AuthRoutesPipelineLazyRouteImport = createFileRoute(
  '/_auth-routes/pipeline',
)()
const AuthRoutesPAndLLazyRouteImport = createFileRoute(
  '/_auth-routes/p-and-l',
)()
const AuthRoutesMonteCarloLazyRouteImport = createFileRoute(
  '/_auth-routes/monte-carlo',
)()
const AuthRoutesDashboardLazyRouteImport = createFileRoute(
  '/_auth-routes/dashboard',
)()
const AuthRoutesAdminLazyRouteImport = createFileRoute('/_auth-routes/admin')()
const AuthRoutesAdminIndexLazyRouteImport = createFileRoute(
  '/_auth-routes/admin/',
)()
const AuthRoutesAdminTestWorkerLazyRouteImport = createFileRoute(
  '/_auth-routes/admin/test-worker',
)()
const AuthRoutesAdminTestCalculationLazyRouteImport = createFileRoute(
  '/_auth-routes/admin/test-calculation',
)()
const AuthRoutesAdminImportReviewLazyRouteImport = createFileRoute(
  '/_auth-routes/admin/import-review',
)()
const AuthRoutesAdminExcelIoLazyRouteImport = createFileRoute(
  '/_auth-routes/admin/excel-io',
)()
const AuthRoutesAdminDataManagementLazyRouteImport = createFileRoute(
  '/_auth-routes/admin/data-management',
)()

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth-error',
  path: '/auth-error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoutesRoute = AuthRoutesRouteImport.update({
  id: '/_auth-routes',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoutesPipelineLazyRoute = AuthRoutesPipelineLazyRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => AuthRoutesRoute,
} as any).lazy(() =>
  import('./routes/_auth-routes/pipeline.lazy').then((d) => d.Route),
)
const AuthRoutesPAndLLazyRoute = AuthRoutesPAndLLazyRouteImport.update({
  id: '/p-and-l',
  path: '/p-and-l',
  getParentRoute: () => AuthRoutesRoute,
} as any).lazy(() =>
  import('./routes/_auth-routes/p-and-l.lazy').then((d) => d.Route),
)
const AuthRoutesMonteCarloLazyRoute =
  AuthRoutesMonteCarloLazyRouteImport.update({
    id: '/monte-carlo',
    path: '/monte-carlo',
    getParentRoute: () => AuthRoutesRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/monte-carlo.lazy').then((d) => d.Route),
  )
const AuthRoutesDashboardLazyRoute = AuthRoutesDashboardLazyRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoutesRoute,
} as any).lazy(() =>
  import('./routes/_auth-routes/dashboard.lazy').then((d) => d.Route),
)
const AuthRoutesAdminLazyRoute = AuthRoutesAdminLazyRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoutesRoute,
} as any).lazy(() =>
  import('./routes/_auth-routes/admin.lazy').then((d) => d.Route),
)
const AuthRoutesAdminIndexLazyRoute =
  AuthRoutesAdminIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/admin/index.lazy').then((d) => d.Route),
  )
const AuthRoutesAdminTestWorkerLazyRoute =
  AuthRoutesAdminTestWorkerLazyRouteImport.update({
    id: '/test-worker',
    path: '/test-worker',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/admin/test-worker.lazy').then((d) => d.Route),
  )
const AuthRoutesAdminTestCalculationLazyRoute =
  AuthRoutesAdminTestCalculationLazyRouteImport.update({
    id: '/test-calculation',
    path: '/test-calculation',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/admin/test-calculation.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthRoutesAdminImportReviewLazyRoute =
  AuthRoutesAdminImportReviewLazyRouteImport.update({
    id: '/import-review',
    path: '/import-review',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/admin/import-review.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthRoutesAdminExcelIoLazyRoute =
  AuthRoutesAdminExcelIoLazyRouteImport.update({
    id: '/excel-io',
    path: '/excel-io',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/admin/excel-io.lazy').then((d) => d.Route),
  )
const AuthRoutesAdminDataManagementLazyRoute =
  AuthRoutesAdminDataManagementLazyRouteImport.update({
    id: '/data-management',
    path: '/data-management',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/admin/data-management.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthRoutesAdminVariableCostsRoute =
  AuthRoutesAdminVariableCostsRouteImport.update({
    id: '/variableCosts',
    path: '/variableCosts',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminVariableCostRoute =
  AuthRoutesAdminVariableCostRouteImport.update({
    id: '/variableCost',
    path: '/variableCost',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminUsersRoute = AuthRoutesAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminUserRoute = AuthRoutesAdminUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminUptakesRoute = AuthRoutesAdminUptakesRouteImport.update({
  id: '/uptakes',
  path: '/uptakes',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminUptakeRoute = AuthRoutesAdminUptakeRouteImport.update({
  id: '/uptake',
  path: '/uptake',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminTableViewsRoute =
  AuthRoutesAdminTableViewsRouteImport.update({
    id: '/tableViews',
    path: '/tableViews',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminTableViewRoute =
  AuthRoutesAdminTableViewRouteImport.update({
    id: '/tableView',
    path: '/tableView',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminScenariosRoute =
  AuthRoutesAdminScenariosRouteImport.update({
    id: '/scenarios',
    path: '/scenarios',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminScenarioRoute = AuthRoutesAdminScenarioRouteImport.update({
  id: '/scenario',
  path: '/scenario',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminSalesRoute = AuthRoutesAdminSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminSaleRoute = AuthRoutesAdminSaleRouteImport.update({
  id: '/sale',
  path: '/sale',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminRoyaltyRoute = AuthRoutesAdminRoyaltyRouteImport.update({
  id: '/royalty',
  path: '/royalty',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminRoyaltiesRoute =
  AuthRoutesAdminRoyaltiesRouteImport.update({
    id: '/royalties',
    path: '/royalties',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminProjectsRoute = AuthRoutesAdminProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminProjectPhasesRoute =
  AuthRoutesAdminProjectPhasesRouteImport.update({
    id: '/projectPhases',
    path: '/projectPhases',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminProjectPhaseRoute =
  AuthRoutesAdminProjectPhaseRouteImport.update({
    id: '/projectPhase',
    path: '/projectPhase',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminProjectCategoryRoute =
  AuthRoutesAdminProjectCategoryRouteImport.update({
    id: '/projectCategory',
    path: '/projectCategory',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminProjectCategoriesRoute =
  AuthRoutesAdminProjectCategoriesRouteImport.update({
    id: '/projectCategories',
    path: '/projectCategories',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminProjectRoute = AuthRoutesAdminProjectRouteImport.update({
  id: '/project',
  path: '/project',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminPhasesRoute = AuthRoutesAdminPhasesRouteImport.update({
  id: '/phases',
  path: '/phases',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminPhaseRoute = AuthRoutesAdminPhaseRouteImport.update({
  id: '/phase',
  path: '/phase',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminPeriodsRoute = AuthRoutesAdminPeriodsRouteImport.update({
  id: '/periods',
  path: '/periods',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminPeriodRoute = AuthRoutesAdminPeriodRouteImport.update({
  id: '/period',
  path: '/period',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminMilestonesRoute =
  AuthRoutesAdminMilestonesRouteImport.update({
    id: '/milestones',
    path: '/milestones',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminMilestoneRoute =
  AuthRoutesAdminMilestoneRouteImport.update({
    id: '/milestone',
    path: '/milestone',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminFinancialsRoute =
  AuthRoutesAdminFinancialsRouteImport.update({
    id: '/financials',
    path: '/financials',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminFinancialRoute =
  AuthRoutesAdminFinancialRouteImport.update({
    id: '/financial',
    path: '/financial',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminFilesRoute = AuthRoutesAdminFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminFileRoute = AuthRoutesAdminFileRouteImport.update({
  id: '/file',
  path: '/file',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminConfigsRoute = AuthRoutesAdminConfigsRouteImport.update({
  id: '/configs',
  path: '/configs',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminConfigRoute = AuthRoutesAdminConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminCommentsRoute = AuthRoutesAdminCommentsRouteImport.update({
  id: '/comments',
  path: '/comments',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminCommentRoute = AuthRoutesAdminCommentRouteImport.update({
  id: '/comment',
  path: '/comment',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminCategoryValuesRoute =
  AuthRoutesAdminCategoryValuesRouteImport.update({
    id: '/categoryValues',
    path: '/categoryValues',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminCategoryValueRoute =
  AuthRoutesAdminCategoryValueRouteImport.update({
    id: '/categoryValue',
    path: '/categoryValue',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminCategoryRoute = AuthRoutesAdminCategoryRouteImport.update({
  id: '/category',
  path: '/category',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminCategoriesRoute =
  AuthRoutesAdminCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminActionsRoute = AuthRoutesAdminActionsRouteImport.update({
  id: '/actions',
  path: '/actions',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminActionOperationsRoute =
  AuthRoutesAdminActionOperationsRouteImport.update({
    id: '/actionOperations',
    path: '/actionOperations',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminActionOperationRoute =
  AuthRoutesAdminActionOperationRouteImport.update({
    id: '/actionOperation',
    path: '/actionOperation',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminActionRoute = AuthRoutesAdminActionRouteImport.update({
  id: '/action',
  path: '/action',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth-error': typeof AuthErrorRoute
  '/login': typeof LoginRoute
  '/security': typeof SecurityRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/admin': typeof AuthRoutesAdminLazyRouteWithChildren
  '/dashboard': typeof AuthRoutesDashboardLazyRoute
  '/monte-carlo': typeof AuthRoutesMonteCarloLazyRoute
  '/p-and-l': typeof AuthRoutesPAndLLazyRoute
  '/pipeline': typeof AuthRoutesPipelineLazyRoute
  '/admin/action': typeof AuthRoutesAdminActionRoute
  '/admin/actionOperation': typeof AuthRoutesAdminActionOperationRoute
  '/admin/actionOperations': typeof AuthRoutesAdminActionOperationsRoute
  '/admin/actions': typeof AuthRoutesAdminActionsRoute
  '/admin/categories': typeof AuthRoutesAdminCategoriesRoute
  '/admin/category': typeof AuthRoutesAdminCategoryRoute
  '/admin/categoryValue': typeof AuthRoutesAdminCategoryValueRoute
  '/admin/categoryValues': typeof AuthRoutesAdminCategoryValuesRoute
  '/admin/comment': typeof AuthRoutesAdminCommentRoute
  '/admin/comments': typeof AuthRoutesAdminCommentsRoute
  '/admin/config': typeof AuthRoutesAdminConfigRoute
  '/admin/configs': typeof AuthRoutesAdminConfigsRoute
  '/admin/file': typeof AuthRoutesAdminFileRoute
  '/admin/files': typeof AuthRoutesAdminFilesRoute
  '/admin/financial': typeof AuthRoutesAdminFinancialRoute
  '/admin/financials': typeof AuthRoutesAdminFinancialsRoute
  '/admin/milestone': typeof AuthRoutesAdminMilestoneRoute
  '/admin/milestones': typeof AuthRoutesAdminMilestonesRoute
  '/admin/period': typeof AuthRoutesAdminPeriodRoute
  '/admin/periods': typeof AuthRoutesAdminPeriodsRoute
  '/admin/phase': typeof AuthRoutesAdminPhaseRoute
  '/admin/phases': typeof AuthRoutesAdminPhasesRoute
  '/admin/project': typeof AuthRoutesAdminProjectRoute
  '/admin/projectCategories': typeof AuthRoutesAdminProjectCategoriesRoute
  '/admin/projectCategory': typeof AuthRoutesAdminProjectCategoryRoute
  '/admin/projectPhase': typeof AuthRoutesAdminProjectPhaseRoute
  '/admin/projectPhases': typeof AuthRoutesAdminProjectPhasesRoute
  '/admin/projects': typeof AuthRoutesAdminProjectsRoute
  '/admin/royalties': typeof AuthRoutesAdminRoyaltiesRoute
  '/admin/royalty': typeof AuthRoutesAdminRoyaltyRoute
  '/admin/sale': typeof AuthRoutesAdminSaleRoute
  '/admin/sales': typeof AuthRoutesAdminSalesRoute
  '/admin/scenario': typeof AuthRoutesAdminScenarioRoute
  '/admin/scenarios': typeof AuthRoutesAdminScenariosRoute
  '/admin/tableView': typeof AuthRoutesAdminTableViewRoute
  '/admin/tableViews': typeof AuthRoutesAdminTableViewsRoute
  '/admin/uptake': typeof AuthRoutesAdminUptakeRoute
  '/admin/uptakes': typeof AuthRoutesAdminUptakesRoute
  '/admin/user': typeof AuthRoutesAdminUserRoute
  '/admin/users': typeof AuthRoutesAdminUsersRoute
  '/admin/variableCost': typeof AuthRoutesAdminVariableCostRoute
  '/admin/variableCosts': typeof AuthRoutesAdminVariableCostsRoute
  '/admin/data-management': typeof AuthRoutesAdminDataManagementLazyRoute
  '/admin/excel-io': typeof AuthRoutesAdminExcelIoLazyRoute
  '/admin/import-review': typeof AuthRoutesAdminImportReviewLazyRoute
  '/admin/test-calculation': typeof AuthRoutesAdminTestCalculationLazyRoute
  '/admin/test-worker': typeof AuthRoutesAdminTestWorkerLazyRoute
  '/admin/': typeof AuthRoutesAdminIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth-error': typeof AuthErrorRoute
  '/login': typeof LoginRoute
  '/security': typeof SecurityRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/dashboard': typeof AuthRoutesDashboardLazyRoute
  '/monte-carlo': typeof AuthRoutesMonteCarloLazyRoute
  '/p-and-l': typeof AuthRoutesPAndLLazyRoute
  '/pipeline': typeof AuthRoutesPipelineLazyRoute
  '/admin/action': typeof AuthRoutesAdminActionRoute
  '/admin/actionOperation': typeof AuthRoutesAdminActionOperationRoute
  '/admin/actionOperations': typeof AuthRoutesAdminActionOperationsRoute
  '/admin/actions': typeof AuthRoutesAdminActionsRoute
  '/admin/categories': typeof AuthRoutesAdminCategoriesRoute
  '/admin/category': typeof AuthRoutesAdminCategoryRoute
  '/admin/categoryValue': typeof AuthRoutesAdminCategoryValueRoute
  '/admin/categoryValues': typeof AuthRoutesAdminCategoryValuesRoute
  '/admin/comment': typeof AuthRoutesAdminCommentRoute
  '/admin/comments': typeof AuthRoutesAdminCommentsRoute
  '/admin/config': typeof AuthRoutesAdminConfigRoute
  '/admin/configs': typeof AuthRoutesAdminConfigsRoute
  '/admin/file': typeof AuthRoutesAdminFileRoute
  '/admin/files': typeof AuthRoutesAdminFilesRoute
  '/admin/financial': typeof AuthRoutesAdminFinancialRoute
  '/admin/financials': typeof AuthRoutesAdminFinancialsRoute
  '/admin/milestone': typeof AuthRoutesAdminMilestoneRoute
  '/admin/milestones': typeof AuthRoutesAdminMilestonesRoute
  '/admin/period': typeof AuthRoutesAdminPeriodRoute
  '/admin/periods': typeof AuthRoutesAdminPeriodsRoute
  '/admin/phase': typeof AuthRoutesAdminPhaseRoute
  '/admin/phases': typeof AuthRoutesAdminPhasesRoute
  '/admin/project': typeof AuthRoutesAdminProjectRoute
  '/admin/projectCategories': typeof AuthRoutesAdminProjectCategoriesRoute
  '/admin/projectCategory': typeof AuthRoutesAdminProjectCategoryRoute
  '/admin/projectPhase': typeof AuthRoutesAdminProjectPhaseRoute
  '/admin/projectPhases': typeof AuthRoutesAdminProjectPhasesRoute
  '/admin/projects': typeof AuthRoutesAdminProjectsRoute
  '/admin/royalties': typeof AuthRoutesAdminRoyaltiesRoute
  '/admin/royalty': typeof AuthRoutesAdminRoyaltyRoute
  '/admin/sale': typeof AuthRoutesAdminSaleRoute
  '/admin/sales': typeof AuthRoutesAdminSalesRoute
  '/admin/scenario': typeof AuthRoutesAdminScenarioRoute
  '/admin/scenarios': typeof AuthRoutesAdminScenariosRoute
  '/admin/tableView': typeof AuthRoutesAdminTableViewRoute
  '/admin/tableViews': typeof AuthRoutesAdminTableViewsRoute
  '/admin/uptake': typeof AuthRoutesAdminUptakeRoute
  '/admin/uptakes': typeof AuthRoutesAdminUptakesRoute
  '/admin/user': typeof AuthRoutesAdminUserRoute
  '/admin/users': typeof AuthRoutesAdminUsersRoute
  '/admin/variableCost': typeof AuthRoutesAdminVariableCostRoute
  '/admin/variableCosts': typeof AuthRoutesAdminVariableCostsRoute
  '/admin/data-management': typeof AuthRoutesAdminDataManagementLazyRoute
  '/admin/excel-io': typeof AuthRoutesAdminExcelIoLazyRoute
  '/admin/import-review': typeof AuthRoutesAdminImportReviewLazyRoute
  '/admin/test-calculation': typeof AuthRoutesAdminTestCalculationLazyRoute
  '/admin/test-worker': typeof AuthRoutesAdminTestWorkerLazyRoute
  '/admin': typeof AuthRoutesAdminIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth-routes': typeof AuthRoutesRouteWithChildren
  '/auth-error': typeof AuthErrorRoute
  '/login': typeof LoginRoute
  '/security': typeof SecurityRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_auth-routes/admin': typeof AuthRoutesAdminLazyRouteWithChildren
  '/_auth-routes/dashboard': typeof AuthRoutesDashboardLazyRoute
  '/_auth-routes/monte-carlo': typeof AuthRoutesMonteCarloLazyRoute
  '/_auth-routes/p-and-l': typeof AuthRoutesPAndLLazyRoute
  '/_auth-routes/pipeline': typeof AuthRoutesPipelineLazyRoute
  '/_auth-routes/admin/action': typeof AuthRoutesAdminActionRoute
  '/_auth-routes/admin/actionOperation': typeof AuthRoutesAdminActionOperationRoute
  '/_auth-routes/admin/actionOperations': typeof AuthRoutesAdminActionOperationsRoute
  '/_auth-routes/admin/actions': typeof AuthRoutesAdminActionsRoute
  '/_auth-routes/admin/categories': typeof AuthRoutesAdminCategoriesRoute
  '/_auth-routes/admin/category': typeof AuthRoutesAdminCategoryRoute
  '/_auth-routes/admin/categoryValue': typeof AuthRoutesAdminCategoryValueRoute
  '/_auth-routes/admin/categoryValues': typeof AuthRoutesAdminCategoryValuesRoute
  '/_auth-routes/admin/comment': typeof AuthRoutesAdminCommentRoute
  '/_auth-routes/admin/comments': typeof AuthRoutesAdminCommentsRoute
  '/_auth-routes/admin/config': typeof AuthRoutesAdminConfigRoute
  '/_auth-routes/admin/configs': typeof AuthRoutesAdminConfigsRoute
  '/_auth-routes/admin/file': typeof AuthRoutesAdminFileRoute
  '/_auth-routes/admin/files': typeof AuthRoutesAdminFilesRoute
  '/_auth-routes/admin/financial': typeof AuthRoutesAdminFinancialRoute
  '/_auth-routes/admin/financials': typeof AuthRoutesAdminFinancialsRoute
  '/_auth-routes/admin/milestone': typeof AuthRoutesAdminMilestoneRoute
  '/_auth-routes/admin/milestones': typeof AuthRoutesAdminMilestonesRoute
  '/_auth-routes/admin/period': typeof AuthRoutesAdminPeriodRoute
  '/_auth-routes/admin/periods': typeof AuthRoutesAdminPeriodsRoute
  '/_auth-routes/admin/phase': typeof AuthRoutesAdminPhaseRoute
  '/_auth-routes/admin/phases': typeof AuthRoutesAdminPhasesRoute
  '/_auth-routes/admin/project': typeof AuthRoutesAdminProjectRoute
  '/_auth-routes/admin/projectCategories': typeof AuthRoutesAdminProjectCategoriesRoute
  '/_auth-routes/admin/projectCategory': typeof AuthRoutesAdminProjectCategoryRoute
  '/_auth-routes/admin/projectPhase': typeof AuthRoutesAdminProjectPhaseRoute
  '/_auth-routes/admin/projectPhases': typeof AuthRoutesAdminProjectPhasesRoute
  '/_auth-routes/admin/projects': typeof AuthRoutesAdminProjectsRoute
  '/_auth-routes/admin/royalties': typeof AuthRoutesAdminRoyaltiesRoute
  '/_auth-routes/admin/royalty': typeof AuthRoutesAdminRoyaltyRoute
  '/_auth-routes/admin/sale': typeof AuthRoutesAdminSaleRoute
  '/_auth-routes/admin/sales': typeof AuthRoutesAdminSalesRoute
  '/_auth-routes/admin/scenario': typeof AuthRoutesAdminScenarioRoute
  '/_auth-routes/admin/scenarios': typeof AuthRoutesAdminScenariosRoute
  '/_auth-routes/admin/tableView': typeof AuthRoutesAdminTableViewRoute
  '/_auth-routes/admin/tableViews': typeof AuthRoutesAdminTableViewsRoute
  '/_auth-routes/admin/uptake': typeof AuthRoutesAdminUptakeRoute
  '/_auth-routes/admin/uptakes': typeof AuthRoutesAdminUptakesRoute
  '/_auth-routes/admin/user': typeof AuthRoutesAdminUserRoute
  '/_auth-routes/admin/users': typeof AuthRoutesAdminUsersRoute
  '/_auth-routes/admin/variableCost': typeof AuthRoutesAdminVariableCostRoute
  '/_auth-routes/admin/variableCosts': typeof AuthRoutesAdminVariableCostsRoute
  '/_auth-routes/admin/data-management': typeof AuthRoutesAdminDataManagementLazyRoute
  '/_auth-routes/admin/excel-io': typeof AuthRoutesAdminExcelIoLazyRoute
  '/_auth-routes/admin/import-review': typeof AuthRoutesAdminImportReviewLazyRoute
  '/_auth-routes/admin/test-calculation': typeof AuthRoutesAdminTestCalculationLazyRoute
  '/_auth-routes/admin/test-worker': typeof AuthRoutesAdminTestWorkerLazyRoute
  '/_auth-routes/admin/': typeof AuthRoutesAdminIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth-error'
    | '/login'
    | '/security'
    | '/unauthorized'
    | '/admin'
    | '/dashboard'
    | '/monte-carlo'
    | '/p-and-l'
    | '/pipeline'
    | '/admin/action'
    | '/admin/actionOperation'
    | '/admin/actionOperations'
    | '/admin/actions'
    | '/admin/categories'
    | '/admin/category'
    | '/admin/categoryValue'
    | '/admin/categoryValues'
    | '/admin/comment'
    | '/admin/comments'
    | '/admin/config'
    | '/admin/configs'
    | '/admin/file'
    | '/admin/files'
    | '/admin/financial'
    | '/admin/financials'
    | '/admin/milestone'
    | '/admin/milestones'
    | '/admin/period'
    | '/admin/periods'
    | '/admin/phase'
    | '/admin/phases'
    | '/admin/project'
    | '/admin/projectCategories'
    | '/admin/projectCategory'
    | '/admin/projectPhase'
    | '/admin/projectPhases'
    | '/admin/projects'
    | '/admin/royalties'
    | '/admin/royalty'
    | '/admin/sale'
    | '/admin/sales'
    | '/admin/scenario'
    | '/admin/scenarios'
    | '/admin/tableView'
    | '/admin/tableViews'
    | '/admin/uptake'
    | '/admin/uptakes'
    | '/admin/user'
    | '/admin/users'
    | '/admin/variableCost'
    | '/admin/variableCosts'
    | '/admin/data-management'
    | '/admin/excel-io'
    | '/admin/import-review'
    | '/admin/test-calculation'
    | '/admin/test-worker'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-error'
    | '/login'
    | '/security'
    | '/unauthorized'
    | '/dashboard'
    | '/monte-carlo'
    | '/p-and-l'
    | '/pipeline'
    | '/admin/action'
    | '/admin/actionOperation'
    | '/admin/actionOperations'
    | '/admin/actions'
    | '/admin/categories'
    | '/admin/category'
    | '/admin/categoryValue'
    | '/admin/categoryValues'
    | '/admin/comment'
    | '/admin/comments'
    | '/admin/config'
    | '/admin/configs'
    | '/admin/file'
    | '/admin/files'
    | '/admin/financial'
    | '/admin/financials'
    | '/admin/milestone'
    | '/admin/milestones'
    | '/admin/period'
    | '/admin/periods'
    | '/admin/phase'
    | '/admin/phases'
    | '/admin/project'
    | '/admin/projectCategories'
    | '/admin/projectCategory'
    | '/admin/projectPhase'
    | '/admin/projectPhases'
    | '/admin/projects'
    | '/admin/royalties'
    | '/admin/royalty'
    | '/admin/sale'
    | '/admin/sales'
    | '/admin/scenario'
    | '/admin/scenarios'
    | '/admin/tableView'
    | '/admin/tableViews'
    | '/admin/uptake'
    | '/admin/uptakes'
    | '/admin/user'
    | '/admin/users'
    | '/admin/variableCost'
    | '/admin/variableCosts'
    | '/admin/data-management'
    | '/admin/excel-io'
    | '/admin/import-review'
    | '/admin/test-calculation'
    | '/admin/test-worker'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/_auth-routes'
    | '/auth-error'
    | '/login'
    | '/security'
    | '/unauthorized'
    | '/_auth-routes/admin'
    | '/_auth-routes/dashboard'
    | '/_auth-routes/monte-carlo'
    | '/_auth-routes/p-and-l'
    | '/_auth-routes/pipeline'
    | '/_auth-routes/admin/action'
    | '/_auth-routes/admin/actionOperation'
    | '/_auth-routes/admin/actionOperations'
    | '/_auth-routes/admin/actions'
    | '/_auth-routes/admin/categories'
    | '/_auth-routes/admin/category'
    | '/_auth-routes/admin/categoryValue'
    | '/_auth-routes/admin/categoryValues'
    | '/_auth-routes/admin/comment'
    | '/_auth-routes/admin/comments'
    | '/_auth-routes/admin/config'
    | '/_auth-routes/admin/configs'
    | '/_auth-routes/admin/file'
    | '/_auth-routes/admin/files'
    | '/_auth-routes/admin/financial'
    | '/_auth-routes/admin/financials'
    | '/_auth-routes/admin/milestone'
    | '/_auth-routes/admin/milestones'
    | '/_auth-routes/admin/period'
    | '/_auth-routes/admin/periods'
    | '/_auth-routes/admin/phase'
    | '/_auth-routes/admin/phases'
    | '/_auth-routes/admin/project'
    | '/_auth-routes/admin/projectCategories'
    | '/_auth-routes/admin/projectCategory'
    | '/_auth-routes/admin/projectPhase'
    | '/_auth-routes/admin/projectPhases'
    | '/_auth-routes/admin/projects'
    | '/_auth-routes/admin/royalties'
    | '/_auth-routes/admin/royalty'
    | '/_auth-routes/admin/sale'
    | '/_auth-routes/admin/sales'
    | '/_auth-routes/admin/scenario'
    | '/_auth-routes/admin/scenarios'
    | '/_auth-routes/admin/tableView'
    | '/_auth-routes/admin/tableViews'
    | '/_auth-routes/admin/uptake'
    | '/_auth-routes/admin/uptakes'
    | '/_auth-routes/admin/user'
    | '/_auth-routes/admin/users'
    | '/_auth-routes/admin/variableCost'
    | '/_auth-routes/admin/variableCosts'
    | '/_auth-routes/admin/data-management'
    | '/_auth-routes/admin/excel-io'
    | '/_auth-routes/admin/import-review'
    | '/_auth-routes/admin/test-calculation'
    | '/_auth-routes/admin/test-worker'
    | '/_auth-routes/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoutesRoute: typeof AuthRoutesRouteWithChildren
  AuthErrorRoute: typeof AuthErrorRoute
  LoginRoute: typeof LoginRoute
  SecurityRoute: typeof SecurityRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-error': {
      id: '/auth-error'
      path: '/auth-error'
      fullPath: '/auth-error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-routes': {
      id: '/_auth-routes'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRoutesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-routes/pipeline': {
      id: '/_auth-routes/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof AuthRoutesPipelineLazyRouteImport
      parentRoute: typeof AuthRoutesRoute
    }
    '/_auth-routes/p-and-l': {
      id: '/_auth-routes/p-and-l'
      path: '/p-and-l'
      fullPath: '/p-and-l'
      preLoaderRoute: typeof AuthRoutesPAndLLazyRouteImport
      parentRoute: typeof AuthRoutesRoute
    }
    '/_auth-routes/monte-carlo': {
      id: '/_auth-routes/monte-carlo'
      path: '/monte-carlo'
      fullPath: '/monte-carlo'
      preLoaderRoute: typeof AuthRoutesMonteCarloLazyRouteImport
      parentRoute: typeof AuthRoutesRoute
    }
    '/_auth-routes/dashboard': {
      id: '/_auth-routes/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthRoutesDashboardLazyRouteImport
      parentRoute: typeof AuthRoutesRoute
    }
    '/_auth-routes/admin': {
      id: '/_auth-routes/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthRoutesAdminLazyRouteImport
      parentRoute: typeof AuthRoutesRoute
    }
    '/_auth-routes/admin/': {
      id: '/_auth-routes/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthRoutesAdminIndexLazyRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/test-worker': {
      id: '/_auth-routes/admin/test-worker'
      path: '/test-worker'
      fullPath: '/admin/test-worker'
      preLoaderRoute: typeof AuthRoutesAdminTestWorkerLazyRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/test-calculation': {
      id: '/_auth-routes/admin/test-calculation'
      path: '/test-calculation'
      fullPath: '/admin/test-calculation'
      preLoaderRoute: typeof AuthRoutesAdminTestCalculationLazyRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/import-review': {
      id: '/_auth-routes/admin/import-review'
      path: '/import-review'
      fullPath: '/admin/import-review'
      preLoaderRoute: typeof AuthRoutesAdminImportReviewLazyRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/excel-io': {
      id: '/_auth-routes/admin/excel-io'
      path: '/excel-io'
      fullPath: '/admin/excel-io'
      preLoaderRoute: typeof AuthRoutesAdminExcelIoLazyRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/data-management': {
      id: '/_auth-routes/admin/data-management'
      path: '/data-management'
      fullPath: '/admin/data-management'
      preLoaderRoute: typeof AuthRoutesAdminDataManagementLazyRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/variableCosts': {
      id: '/_auth-routes/admin/variableCosts'
      path: '/variableCosts'
      fullPath: '/admin/variableCosts'
      preLoaderRoute: typeof AuthRoutesAdminVariableCostsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/variableCost': {
      id: '/_auth-routes/admin/variableCost'
      path: '/variableCost'
      fullPath: '/admin/variableCost'
      preLoaderRoute: typeof AuthRoutesAdminVariableCostRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/users': {
      id: '/_auth-routes/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthRoutesAdminUsersRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/user': {
      id: '/_auth-routes/admin/user'
      path: '/user'
      fullPath: '/admin/user'
      preLoaderRoute: typeof AuthRoutesAdminUserRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/uptakes': {
      id: '/_auth-routes/admin/uptakes'
      path: '/uptakes'
      fullPath: '/admin/uptakes'
      preLoaderRoute: typeof AuthRoutesAdminUptakesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/uptake': {
      id: '/_auth-routes/admin/uptake'
      path: '/uptake'
      fullPath: '/admin/uptake'
      preLoaderRoute: typeof AuthRoutesAdminUptakeRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/tableViews': {
      id: '/_auth-routes/admin/tableViews'
      path: '/tableViews'
      fullPath: '/admin/tableViews'
      preLoaderRoute: typeof AuthRoutesAdminTableViewsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/tableView': {
      id: '/_auth-routes/admin/tableView'
      path: '/tableView'
      fullPath: '/admin/tableView'
      preLoaderRoute: typeof AuthRoutesAdminTableViewRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/scenarios': {
      id: '/_auth-routes/admin/scenarios'
      path: '/scenarios'
      fullPath: '/admin/scenarios'
      preLoaderRoute: typeof AuthRoutesAdminScenariosRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/scenario': {
      id: '/_auth-routes/admin/scenario'
      path: '/scenario'
      fullPath: '/admin/scenario'
      preLoaderRoute: typeof AuthRoutesAdminScenarioRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/sales': {
      id: '/_auth-routes/admin/sales'
      path: '/sales'
      fullPath: '/admin/sales'
      preLoaderRoute: typeof AuthRoutesAdminSalesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/sale': {
      id: '/_auth-routes/admin/sale'
      path: '/sale'
      fullPath: '/admin/sale'
      preLoaderRoute: typeof AuthRoutesAdminSaleRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/royalty': {
      id: '/_auth-routes/admin/royalty'
      path: '/royalty'
      fullPath: '/admin/royalty'
      preLoaderRoute: typeof AuthRoutesAdminRoyaltyRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/royalties': {
      id: '/_auth-routes/admin/royalties'
      path: '/royalties'
      fullPath: '/admin/royalties'
      preLoaderRoute: typeof AuthRoutesAdminRoyaltiesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/projects': {
      id: '/_auth-routes/admin/projects'
      path: '/projects'
      fullPath: '/admin/projects'
      preLoaderRoute: typeof AuthRoutesAdminProjectsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/projectPhases': {
      id: '/_auth-routes/admin/projectPhases'
      path: '/projectPhases'
      fullPath: '/admin/projectPhases'
      preLoaderRoute: typeof AuthRoutesAdminProjectPhasesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/projectPhase': {
      id: '/_auth-routes/admin/projectPhase'
      path: '/projectPhase'
      fullPath: '/admin/projectPhase'
      preLoaderRoute: typeof AuthRoutesAdminProjectPhaseRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/projectCategory': {
      id: '/_auth-routes/admin/projectCategory'
      path: '/projectCategory'
      fullPath: '/admin/projectCategory'
      preLoaderRoute: typeof AuthRoutesAdminProjectCategoryRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/projectCategories': {
      id: '/_auth-routes/admin/projectCategories'
      path: '/projectCategories'
      fullPath: '/admin/projectCategories'
      preLoaderRoute: typeof AuthRoutesAdminProjectCategoriesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/project': {
      id: '/_auth-routes/admin/project'
      path: '/project'
      fullPath: '/admin/project'
      preLoaderRoute: typeof AuthRoutesAdminProjectRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/phases': {
      id: '/_auth-routes/admin/phases'
      path: '/phases'
      fullPath: '/admin/phases'
      preLoaderRoute: typeof AuthRoutesAdminPhasesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/phase': {
      id: '/_auth-routes/admin/phase'
      path: '/phase'
      fullPath: '/admin/phase'
      preLoaderRoute: typeof AuthRoutesAdminPhaseRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/periods': {
      id: '/_auth-routes/admin/periods'
      path: '/periods'
      fullPath: '/admin/periods'
      preLoaderRoute: typeof AuthRoutesAdminPeriodsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/period': {
      id: '/_auth-routes/admin/period'
      path: '/period'
      fullPath: '/admin/period'
      preLoaderRoute: typeof AuthRoutesAdminPeriodRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/milestones': {
      id: '/_auth-routes/admin/milestones'
      path: '/milestones'
      fullPath: '/admin/milestones'
      preLoaderRoute: typeof AuthRoutesAdminMilestonesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/milestone': {
      id: '/_auth-routes/admin/milestone'
      path: '/milestone'
      fullPath: '/admin/milestone'
      preLoaderRoute: typeof AuthRoutesAdminMilestoneRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/financials': {
      id: '/_auth-routes/admin/financials'
      path: '/financials'
      fullPath: '/admin/financials'
      preLoaderRoute: typeof AuthRoutesAdminFinancialsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/financial': {
      id: '/_auth-routes/admin/financial'
      path: '/financial'
      fullPath: '/admin/financial'
      preLoaderRoute: typeof AuthRoutesAdminFinancialRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/files': {
      id: '/_auth-routes/admin/files'
      path: '/files'
      fullPath: '/admin/files'
      preLoaderRoute: typeof AuthRoutesAdminFilesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/file': {
      id: '/_auth-routes/admin/file'
      path: '/file'
      fullPath: '/admin/file'
      preLoaderRoute: typeof AuthRoutesAdminFileRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/configs': {
      id: '/_auth-routes/admin/configs'
      path: '/configs'
      fullPath: '/admin/configs'
      preLoaderRoute: typeof AuthRoutesAdminConfigsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/config': {
      id: '/_auth-routes/admin/config'
      path: '/config'
      fullPath: '/admin/config'
      preLoaderRoute: typeof AuthRoutesAdminConfigRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/comments': {
      id: '/_auth-routes/admin/comments'
      path: '/comments'
      fullPath: '/admin/comments'
      preLoaderRoute: typeof AuthRoutesAdminCommentsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/comment': {
      id: '/_auth-routes/admin/comment'
      path: '/comment'
      fullPath: '/admin/comment'
      preLoaderRoute: typeof AuthRoutesAdminCommentRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/categoryValues': {
      id: '/_auth-routes/admin/categoryValues'
      path: '/categoryValues'
      fullPath: '/admin/categoryValues'
      preLoaderRoute: typeof AuthRoutesAdminCategoryValuesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/categoryValue': {
      id: '/_auth-routes/admin/categoryValue'
      path: '/categoryValue'
      fullPath: '/admin/categoryValue'
      preLoaderRoute: typeof AuthRoutesAdminCategoryValueRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/category': {
      id: '/_auth-routes/admin/category'
      path: '/category'
      fullPath: '/admin/category'
      preLoaderRoute: typeof AuthRoutesAdminCategoryRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/categories': {
      id: '/_auth-routes/admin/categories'
      path: '/categories'
      fullPath: '/admin/categories'
      preLoaderRoute: typeof AuthRoutesAdminCategoriesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/actions': {
      id: '/_auth-routes/admin/actions'
      path: '/actions'
      fullPath: '/admin/actions'
      preLoaderRoute: typeof AuthRoutesAdminActionsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/actionOperations': {
      id: '/_auth-routes/admin/actionOperations'
      path: '/actionOperations'
      fullPath: '/admin/actionOperations'
      preLoaderRoute: typeof AuthRoutesAdminActionOperationsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/actionOperation': {
      id: '/_auth-routes/admin/actionOperation'
      path: '/actionOperation'
      fullPath: '/admin/actionOperation'
      preLoaderRoute: typeof AuthRoutesAdminActionOperationRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/action': {
      id: '/_auth-routes/admin/action'
      path: '/action'
      fullPath: '/admin/action'
      preLoaderRoute: typeof AuthRoutesAdminActionRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
  }
}

interface AuthRoutesAdminLazyRouteChildren {
  AuthRoutesAdminActionRoute: typeof AuthRoutesAdminActionRoute
  AuthRoutesAdminActionOperationRoute: typeof AuthRoutesAdminActionOperationRoute
  AuthRoutesAdminActionOperationsRoute: typeof AuthRoutesAdminActionOperationsRoute
  AuthRoutesAdminActionsRoute: typeof AuthRoutesAdminActionsRoute
  AuthRoutesAdminCategoriesRoute: typeof AuthRoutesAdminCategoriesRoute
  AuthRoutesAdminCategoryRoute: typeof AuthRoutesAdminCategoryRoute
  AuthRoutesAdminCategoryValueRoute: typeof AuthRoutesAdminCategoryValueRoute
  AuthRoutesAdminCategoryValuesRoute: typeof AuthRoutesAdminCategoryValuesRoute
  AuthRoutesAdminCommentRoute: typeof AuthRoutesAdminCommentRoute
  AuthRoutesAdminCommentsRoute: typeof AuthRoutesAdminCommentsRoute
  AuthRoutesAdminConfigRoute: typeof AuthRoutesAdminConfigRoute
  AuthRoutesAdminConfigsRoute: typeof AuthRoutesAdminConfigsRoute
  AuthRoutesAdminFileRoute: typeof AuthRoutesAdminFileRoute
  AuthRoutesAdminFilesRoute: typeof AuthRoutesAdminFilesRoute
  AuthRoutesAdminFinancialRoute: typeof AuthRoutesAdminFinancialRoute
  AuthRoutesAdminFinancialsRoute: typeof AuthRoutesAdminFinancialsRoute
  AuthRoutesAdminMilestoneRoute: typeof AuthRoutesAdminMilestoneRoute
  AuthRoutesAdminMilestonesRoute: typeof AuthRoutesAdminMilestonesRoute
  AuthRoutesAdminPeriodRoute: typeof AuthRoutesAdminPeriodRoute
  AuthRoutesAdminPeriodsRoute: typeof AuthRoutesAdminPeriodsRoute
  AuthRoutesAdminPhaseRoute: typeof AuthRoutesAdminPhaseRoute
  AuthRoutesAdminPhasesRoute: typeof AuthRoutesAdminPhasesRoute
  AuthRoutesAdminProjectRoute: typeof AuthRoutesAdminProjectRoute
  AuthRoutesAdminProjectCategoriesRoute: typeof AuthRoutesAdminProjectCategoriesRoute
  AuthRoutesAdminProjectCategoryRoute: typeof AuthRoutesAdminProjectCategoryRoute
  AuthRoutesAdminProjectPhaseRoute: typeof AuthRoutesAdminProjectPhaseRoute
  AuthRoutesAdminProjectPhasesRoute: typeof AuthRoutesAdminProjectPhasesRoute
  AuthRoutesAdminProjectsRoute: typeof AuthRoutesAdminProjectsRoute
  AuthRoutesAdminRoyaltiesRoute: typeof AuthRoutesAdminRoyaltiesRoute
  AuthRoutesAdminRoyaltyRoute: typeof AuthRoutesAdminRoyaltyRoute
  AuthRoutesAdminSaleRoute: typeof AuthRoutesAdminSaleRoute
  AuthRoutesAdminSalesRoute: typeof AuthRoutesAdminSalesRoute
  AuthRoutesAdminScenarioRoute: typeof AuthRoutesAdminScenarioRoute
  AuthRoutesAdminScenariosRoute: typeof AuthRoutesAdminScenariosRoute
  AuthRoutesAdminTableViewRoute: typeof AuthRoutesAdminTableViewRoute
  AuthRoutesAdminTableViewsRoute: typeof AuthRoutesAdminTableViewsRoute
  AuthRoutesAdminUptakeRoute: typeof AuthRoutesAdminUptakeRoute
  AuthRoutesAdminUptakesRoute: typeof AuthRoutesAdminUptakesRoute
  AuthRoutesAdminUserRoute: typeof AuthRoutesAdminUserRoute
  AuthRoutesAdminUsersRoute: typeof AuthRoutesAdminUsersRoute
  AuthRoutesAdminVariableCostRoute: typeof AuthRoutesAdminVariableCostRoute
  AuthRoutesAdminVariableCostsRoute: typeof AuthRoutesAdminVariableCostsRoute
  AuthRoutesAdminDataManagementLazyRoute: typeof AuthRoutesAdminDataManagementLazyRoute
  AuthRoutesAdminExcelIoLazyRoute: typeof AuthRoutesAdminExcelIoLazyRoute
  AuthRoutesAdminImportReviewLazyRoute: typeof AuthRoutesAdminImportReviewLazyRoute
  AuthRoutesAdminTestCalculationLazyRoute: typeof AuthRoutesAdminTestCalculationLazyRoute
  AuthRoutesAdminTestWorkerLazyRoute: typeof AuthRoutesAdminTestWorkerLazyRoute
  AuthRoutesAdminIndexLazyRoute: typeof AuthRoutesAdminIndexLazyRoute
}

const AuthRoutesAdminLazyRouteChildren: AuthRoutesAdminLazyRouteChildren = {
  AuthRoutesAdminActionRoute: AuthRoutesAdminActionRoute,
  AuthRoutesAdminActionOperationRoute: AuthRoutesAdminActionOperationRoute,
  AuthRoutesAdminActionOperationsRoute: AuthRoutesAdminActionOperationsRoute,
  AuthRoutesAdminActionsRoute: AuthRoutesAdminActionsRoute,
  AuthRoutesAdminCategoriesRoute: AuthRoutesAdminCategoriesRoute,
  AuthRoutesAdminCategoryRoute: AuthRoutesAdminCategoryRoute,
  AuthRoutesAdminCategoryValueRoute: AuthRoutesAdminCategoryValueRoute,
  AuthRoutesAdminCategoryValuesRoute: AuthRoutesAdminCategoryValuesRoute,
  AuthRoutesAdminCommentRoute: AuthRoutesAdminCommentRoute,
  AuthRoutesAdminCommentsRoute: AuthRoutesAdminCommentsRoute,
  AuthRoutesAdminConfigRoute: AuthRoutesAdminConfigRoute,
  AuthRoutesAdminConfigsRoute: AuthRoutesAdminConfigsRoute,
  AuthRoutesAdminFileRoute: AuthRoutesAdminFileRoute,
  AuthRoutesAdminFilesRoute: AuthRoutesAdminFilesRoute,
  AuthRoutesAdminFinancialRoute: AuthRoutesAdminFinancialRoute,
  AuthRoutesAdminFinancialsRoute: AuthRoutesAdminFinancialsRoute,
  AuthRoutesAdminMilestoneRoute: AuthRoutesAdminMilestoneRoute,
  AuthRoutesAdminMilestonesRoute: AuthRoutesAdminMilestonesRoute,
  AuthRoutesAdminPeriodRoute: AuthRoutesAdminPeriodRoute,
  AuthRoutesAdminPeriodsRoute: AuthRoutesAdminPeriodsRoute,
  AuthRoutesAdminPhaseRoute: AuthRoutesAdminPhaseRoute,
  AuthRoutesAdminPhasesRoute: AuthRoutesAdminPhasesRoute,
  AuthRoutesAdminProjectRoute: AuthRoutesAdminProjectRoute,
  AuthRoutesAdminProjectCategoriesRoute: AuthRoutesAdminProjectCategoriesRoute,
  AuthRoutesAdminProjectCategoryRoute: AuthRoutesAdminProjectCategoryRoute,
  AuthRoutesAdminProjectPhaseRoute: AuthRoutesAdminProjectPhaseRoute,
  AuthRoutesAdminProjectPhasesRoute: AuthRoutesAdminProjectPhasesRoute,
  AuthRoutesAdminProjectsRoute: AuthRoutesAdminProjectsRoute,
  AuthRoutesAdminRoyaltiesRoute: AuthRoutesAdminRoyaltiesRoute,
  AuthRoutesAdminRoyaltyRoute: AuthRoutesAdminRoyaltyRoute,
  AuthRoutesAdminSaleRoute: AuthRoutesAdminSaleRoute,
  AuthRoutesAdminSalesRoute: AuthRoutesAdminSalesRoute,
  AuthRoutesAdminScenarioRoute: AuthRoutesAdminScenarioRoute,
  AuthRoutesAdminScenariosRoute: AuthRoutesAdminScenariosRoute,
  AuthRoutesAdminTableViewRoute: AuthRoutesAdminTableViewRoute,
  AuthRoutesAdminTableViewsRoute: AuthRoutesAdminTableViewsRoute,
  AuthRoutesAdminUptakeRoute: AuthRoutesAdminUptakeRoute,
  AuthRoutesAdminUptakesRoute: AuthRoutesAdminUptakesRoute,
  AuthRoutesAdminUserRoute: AuthRoutesAdminUserRoute,
  AuthRoutesAdminUsersRoute: AuthRoutesAdminUsersRoute,
  AuthRoutesAdminVariableCostRoute: AuthRoutesAdminVariableCostRoute,
  AuthRoutesAdminVariableCostsRoute: AuthRoutesAdminVariableCostsRoute,
  AuthRoutesAdminDataManagementLazyRoute:
    AuthRoutesAdminDataManagementLazyRoute,
  AuthRoutesAdminExcelIoLazyRoute: AuthRoutesAdminExcelIoLazyRoute,
  AuthRoutesAdminImportReviewLazyRoute: AuthRoutesAdminImportReviewLazyRoute,
  AuthRoutesAdminTestCalculationLazyRoute:
    AuthRoutesAdminTestCalculationLazyRoute,
  AuthRoutesAdminTestWorkerLazyRoute: AuthRoutesAdminTestWorkerLazyRoute,
  AuthRoutesAdminIndexLazyRoute: AuthRoutesAdminIndexLazyRoute,
}

const AuthRoutesAdminLazyRouteWithChildren =
  AuthRoutesAdminLazyRoute._addFileChildren(AuthRoutesAdminLazyRouteChildren)

interface AuthRoutesRouteChildren {
  AuthRoutesAdminLazyRoute: typeof AuthRoutesAdminLazyRouteWithChildren
  AuthRoutesDashboardLazyRoute: typeof AuthRoutesDashboardLazyRoute
  AuthRoutesMonteCarloLazyRoute: typeof AuthRoutesMonteCarloLazyRoute
  AuthRoutesPAndLLazyRoute: typeof AuthRoutesPAndLLazyRoute
  AuthRoutesPipelineLazyRoute: typeof AuthRoutesPipelineLazyRoute
}

const AuthRoutesRouteChildren: AuthRoutesRouteChildren = {
  AuthRoutesAdminLazyRoute: AuthRoutesAdminLazyRouteWithChildren,
  AuthRoutesDashboardLazyRoute: AuthRoutesDashboardLazyRoute,
  AuthRoutesMonteCarloLazyRoute: AuthRoutesMonteCarloLazyRoute,
  AuthRoutesPAndLLazyRoute: AuthRoutesPAndLLazyRoute,
  AuthRoutesPipelineLazyRoute: AuthRoutesPipelineLazyRoute,
}

const AuthRoutesRouteWithChildren = AuthRoutesRoute._addFileChildren(
  AuthRoutesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoutesRoute: AuthRoutesRouteWithChildren,
  AuthErrorRoute: AuthErrorRoute,
  LoginRoute: LoginRoute,
  SecurityRoute: SecurityRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
